export const formatCompactNumber = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "N/A";
  const numeric = Number(value);
  const abs = Math.abs(numeric);

  if (abs >= 1_000_000_000) return `${(numeric / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `${(numeric / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${(numeric / 1_000).toFixed(2)}K`;

  return numeric.toLocaleString();
};

export const formatPercentage = (value, digits = 2) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "N/A";
  return `${Number(value).toFixed(digits)}%`;
};

export const formatRatio = (value, digits = 2) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "N/A";
  return `${Number(value).toFixed(digits)}x`;
};

export const formatSignedCompact = (value, isPct = false) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "N/A";
  const numeric = Number(value);
  const direction = numeric > 0 ? "+" : "";
  if (isPct) return `${direction}${numeric.toFixed(2)}%`;
  return `${direction}${formatCompactNumber(numeric)}`;
};

export const trendTone = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "neutral";
  if (Number(value) > 0) return "positive";
  if (Number(value) < 0) return "negative";
  return "neutral";
};
